import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { nsOptions } from '../i18n';
import NewTooltip from './NewTooltip';
import QueryModal from './QueryModal';
import {
  QUERY_STATUS_COLORS,
  QUERY_STATUS_NEW,
  QUERY_STATUS_COMMENTED,
  QUERY_STATUS_EDITED,
  QUERY_STATUS_RESOLVED,
  QUERY_STATUS_CLOSED,
} from '../constants';

const STATUS_TOOLTIP_KEYS = {
  [QUERY_STATUS_NEW]: 'inclusion:queries.status-new',
  [QUERY_STATUS_COMMENTED]: 'inclusion:queries.status-commented',
  [QUERY_STATUS_EDITED]: 'inclusion:queries.status-edited',
  [QUERY_STATUS_RESOLVED]: 'inclusion:queries.status-resolved',
  [QUERY_STATUS_CLOSED]: 'inclusion:queries.status-closed',
};

@withTranslation('', nsOptions)
class QueryBell extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    variableName: PropTypes.string.isRequired,
    inclusion: PropTypes.shape().isRequired,
    projectElement: PropTypes.shape().isRequired,
    moduleInstanceId: PropTypes.number,
    // Existing query on this target (or null if none).
    query: PropTypes.shape(),
    // Whether the current user can manage queries (display the default
    // outlined bell to allow creation).
    canManageQueries: PropTypes.bool.isRequired,
    onSaved: PropTypes.func,
  };

  static defaultProps = {
    moduleInstanceId: null,
    query: null,
    onSaved: () => {},
  };

  render() {
    const {
      t, variableName, inclusion, projectElement, moduleInstanceId,
      query, canManageQueries, onSaved,
    } = this.props;

    // No existing query and user has no rights -> render nothing.
    if (!query && !canManageQueries) return null;

    const hasQuery = !!query;
    const colors = hasQuery ? QUERY_STATUS_COLORS[query.current_status] : null;
    const tooltipContent = hasQuery ? (
      <div>
        <div>
          {t('inclusion:queries.tooltip-status')}
          {' : '}
          <strong>
            {t(STATUS_TOOLTIP_KEYS[query.current_status]).toUpperCase()}
          </strong>
        </div>
        {query.current_comment && (
          <div>
            {t('inclusion:queries.tooltip-comment')}
            {' : '}
            <strong>{query.current_comment}</strong>
          </div>
        )}
      </div>
    ) : t('inclusion:queries.create-query');

    // Retour #7: match audit trail icon size and alignment — same
    // class and structure as the audit trail button in ElementBase.
    const bellIcon = (
      <button
        type="button"
        className="no-button-style pl-0 ml-n1"
      >
        <FontAwesomeIcon
          icon={hasQuery ? ['fas', 'bell'] : ['far', 'bell']}
          className="audit-trail-icon"
          style={{ color: colors ? colors.bg : undefined }}
        />
      </button>
    );

    return (
      <NewTooltip content={tooltipContent}>
        <span>
          <QueryModal
            variableName={variableName}
            inclusion={inclusion}
            projectElement={projectElement}
            moduleInstanceId={moduleInstanceId}
            queryId={query ? query.id : null}
            onSaved={onSaved}
          >
            {bellIcon}
          </QueryModal>
        </span>
      </NewTooltip>
    );
  }
}

export default QueryBell;
